/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailBankSendManifestRequestEmailRequest
 */
export interface MailBankSendManifestRequestEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof MailBankSendManifestRequestEmailRequest
     */
    manifestId?: number;
}

/**
 * Check if a given object implements the MailBankSendManifestRequestEmailRequest interface.
 */
export function instanceOfMailBankSendManifestRequestEmailRequest(value: object): value is MailBankSendManifestRequestEmailRequest {
    return true;
}

export function MailBankSendManifestRequestEmailRequestFromJSON(json: any): MailBankSendManifestRequestEmailRequest {
    return MailBankSendManifestRequestEmailRequestFromJSONTyped(json, false);
}

export function MailBankSendManifestRequestEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailBankSendManifestRequestEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'manifestId': json['manifestId'] == null ? undefined : json['manifestId'],
    };
}

export function MailBankSendManifestRequestEmailRequestToJSON(json: any): MailBankSendManifestRequestEmailRequest {
    return MailBankSendManifestRequestEmailRequestToJSONTyped(json, false);
}

export function MailBankSendManifestRequestEmailRequestToJSONTyped(value?: MailBankSendManifestRequestEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'manifestId': value['manifestId'],
    };
}

